import React from "react";
import Footer from "../../Components/Footer/Footer";
import ScrollToTopButton from "../../Components/ScrollToTop/ScrollToTopButton";
import BlogMain from "../BlogMain/BlogMain";

function Blog() {
  return (
    <div className="blog">
      <BlogMain />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default Blog;
